<template>
    <section v-if="ranked.length > 0">
        <div class="flex items-center justify-between gap-4 mb-4">
            <div class="label-section">Per-question distribution · Sorted by score</div>
            <DistributionLegend :max-score="legendMaxScore" :labels="legendLabels" />
        </div>
        <div class="flex flex-col gap-5">
            <div v-for="q in ranked" :key="q.question_id">
                <div class="flex items-start justify-between gap-3 mb-2">
                    <div class="leading-snug">
                        <div class="body-small-bold text-ink">{{ q.title || q.text }}</div>
                        <div v-if="q.title && q.text" class="details text-ink-muted mt-1">{{ q.text }}</div>
                    </div>
                    <div class="flex items-center gap-2 shrink-0">
                        <span class="body-small-bold text-valence-blue-600">{{ formatNumber(q.all_avg, "two-decimals") || "—" }}</span>
                    </div>
                </div>
                <DistributionBar :distribution="q.distribution" :max-score="q.max_score" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { formatNumber } from "~vue/utils/formatNumber";
import { computed } from "vue";

import DistributionBar from "./DistributionBar.vue";
import DistributionLegend from "./DistributionLegend.vue";
import type { PerQuestion } from "./types";

interface Props {
    questions: PerQuestion[];
}

const props = defineProps<Props>();

const ranked = computed(() =>
    props.questions
        .filter((q) => q.is_score && q.distribution.length > 0 && q.all_count > 0)
        .slice()
        .sort((a, b) => (a.all_avg ?? Infinity) - (b.all_avg ?? Infinity)),
);

// Derive a legend from the first question's scale — questions on a template
// share the same scale in practice, so this is enough.
const legendMaxScore = computed(() => ranked.value[0]?.max_score ?? ranked.value[0]?.distribution.length ?? 5);
const legendLabels = computed(() => ranked.value[0]?.scale_labels);
</script>
